<template>
  <Dialog
    :visible.sync="visivel"
    header="Prévia da Declaração de Prestação de Serviços (DPS) com IBS/CBS"
    :modal="true"
    :closable="false"
    class="dialog-visualizacao-dps"
    :style="{ width: '85vw' }"
  >
    <div class="p-fluid">
      <!-- Loading da Simulação -->
      <div v-if="loadingCalculo" class="text-center p-4">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        <p class="mt-2">Simulando valores de IBS/CBS...</p>
      </div>

      <div v-else class="visualizacao-content">
        <!-- PESSOAS -->
        <div class="nacional-section">
          <h2 class="nacional-section-main-title">PESSOAS</h2>
          
          <h3 class="nacional-section-title">Informações Gerais</h3>
          <div class="nacional-block mb-3">
            <div class="p-col-12 p-0">
              <div class="nacional-row">
                <span class="nacional-label">Data de Competência:</span>
                <span class="nacional-value">{{ notaFiscal.dataFatoGerador | formatDate }}</span>
              </div>
              <div class="nacional-row">
                <span class="nacional-label">Preencher as informações IBS/CBS:</span>
                <span class="nacional-value">SIM</span>
              </div>
              <div class="nacional-row">
                <span class="nacional-label">Para fins de apuração do IBS/CBS, o destinatário é o próprio adquirente:</span>
                <span class="nacional-value">{{ informacoesExtras.isDestinatarioAdquirente || 'SIM' }}</span>
              </div>
            </div>
          </div>

          <h3 class="nacional-section-title">Informações do Emitente</h3>
          <div class="nacional-block mb-3">
            <div class="p-col-12 p-0">
              <div class="nacional-row">
                <span class="nacional-label">Você irá emitir esta NFS-e como:</span>
                <span class="nacional-value">{{ informacoesExtras.tipoEmissao || 'PRESTADOR/FORNECEDOR' }}</span>
              </div>
              <div class="nacional-row">
                <span class="nacional-label">CNPJ:</span>
                <span class="nacional-value">{{ prestador.documento | formatDocument }}</span>
              </div>
              <div class="nacional-row" v-if="prestador.inscricaoMunicipal">
                <span class="nacional-label">Indicador Municipal:</span>
                <span class="nacional-value">{{ prestador.inscricaoMunicipal }}</span>
              </div>
              <div class="nacional-row">
                <span class="nacional-label">Nome/Razão Social:</span>
                <span class="nacional-value">{{ prestador.nome }}</span>
              </div>
              <div class="nacional-row" v-if="prestador.cep">
                <span class="nacional-label">CEP:</span>
                <span class="nacional-value">{{ prestador.cep }}</span>
              </div>
              <div class="nacional-row" v-if="prestador.municipio">
                <span class="nacional-label">Município:</span>
                <span class="nacional-value">{{ prestador.municipio }}<span v-if="prestador.estado">/{{ prestador.estado }}</span></span>
              </div>
              <div class="nacional-row" v-if="prestador.bairro">
                <span class="nacional-label">Bairro:</span>
                <span class="nacional-value">{{ prestador.bairro }}</span>
              </div>
              <div class="nacional-row" v-if="prestador.logradouro">
                <span class="nacional-label">Logradouro:</span>
                <span class="nacional-value">{{ prestador.logradouro }}</span>
              </div>
              <div class="nacional-row" v-if="prestador.numero">
                <span class="nacional-label">Número:</span>
                <span class="nacional-value">{{ prestador.numero }}</span>
              </div>
            </div>
          </div>

          <h3 class="nacional-section-title">Tomador/Adquirente do Serviço</h3>
          <div class="nacional-block mb-3" v-if="tomador">
            <div class="p-col-12 p-0">
              <div class="nacional-row" v-if="tomador.documento">
                <span class="nacional-label">{{ tomador.documento.length > 11 ? 'CNPJ:' : 'CPF:' }}</span>
                <span class="nacional-value">{{ tomador.documento | formatDocument }}</span>
              </div>
              <div class="nacional-row">
                <span class="nacional-label">Nome/Razão Social:</span>
                <span class="nacional-value">{{ tomador.nome }}</span>
              </div>
            </div>
          </div>
          <div class="nacional-block mb-3" v-else>
            <div class="p-col-12 p-0">
              <div class="nacional-row">
                <span class="nacional-label">Tomador:</span>
                <span class="nacional-value">Não identificado.</span>
              </div>
            </div>
          </div>
        </div>

        <!-- SERVIÇO -->
        <div class="nacional-section mt-4">
          <h2 class="nacional-section-main-title">SERVIÇO</h2>
          
          <h3 class="nacional-section-title">Serviço Prestado</h3>
          <div class="nacional-block mb-3">
            <div class="p-col-12 p-0">
              <div class="nacional-row" v-if="servicoNacional && servicoNacional.servicoNacional">
                <span class="nacional-label">Código completo do serviço:</span>
                <span class="nacional-value">{{ servicoNacional.servicoNacional.codigoServico }}</span>
              </div>
              <div class="nacional-row" v-if="servicoNacional && servicoNacional.servicoNacional">
                <span class="nacional-label">Descrição do serviço:</span>
                <span class="nacional-value">{{ servicoNacional.servicoNacional.nomeServico }}</span>
              </div>
              <div class="nacional-row" v-if="informacoesExtras.nbsDetalhe">
                <span class="nacional-label">Item da NBS correspondente ao serviço/fornecimento prestado:</span>
                <span class="nacional-value">{{ informacoesExtras.nbsDetalhe }}</span>
              </div>
              <div class="nacional-row" v-if="informacoesExtras.indopDetalhe">
                <span class="nacional-label">Código indicador da operação:</span>
                <span class="nacional-value">{{ informacoesExtras.indopDetalhe }}</span>
              </div>
              <div class="nacional-row">
                <span class="nacional-label">Local do Fornecimento/Prestação do Serviço:</span>
                <span class="nacional-value">{{ informacoesExtras.ufPrestacao }}</span>
              </div>
              <div class="nacional-row">
                <span class="nacional-label">Local de Incidência do ISSQN:</span>
                <span class="nacional-value">{{ informacoesExtras.ufIncidencia }}</span>
              </div>
              <div class="nacional-row">
                <span class="nacional-label">Descrição do Serviço/Fornecimento:</span>
                <span class="nacional-value" style="white-space: pre-wrap;">{{ notaFiscal.discriminacaoServico }}</span>
              </div>
            </div>
          </div>
        </div>        <hr />

        <!-- Estrutura de Prévia dos Valores -->
        <div class="previa-valores-container mt-4">
          <h3 class="previa-titulo text-uppercase mb-3">PRÉVIA DOS VALORES DA NFS-E</h3>

          <!-- ISSQN Calculado -->
          <div class="previa-section mb-4">
            <h4 class="section-title">ISSQN calculado</h4>
            <div class="previa-body">
              <div class="linha-pontilhada linha-zebra">
                <span class="label">Serviço prestado:</span>
                <span class="dots"></span>
                <span class="value">{{ valorTotalServico | currency }}</span>
              </div>
              <div class="linha-pontilhada linha-zebra">
                <span class="label">Base de cálculo:</span>
                <span class="dots"></span>
                <span class="value">{{ baseCalculoIssqn | currency }}</span>
              </div>
              <div class="linha-pontilhada linha-zebra">
                <span class="label">Alíquota aplicada:</span>
                <span class="dots"></span>
                <span class="value">{{ notaFiscal.aliquota | percent }}</span>
              </div>
              <div class="linha-pontilhada linha-zebra">
                <span class="label">ISSQN:</span>
                <span class="dots"></span>
                <span class="value">{{ notaFiscal.valorIss | currency }}</span>
              </div>
            </div>
          </div>

          <!-- Tributação federal -->
          <div class="previa-section mb-4">
            <h4 class="section-title">Tributação federal</h4>
            <div class="previa-body">
              <div class="linha-pontilhada linha-zebra">
                <span class="label">PIS - Débito Apuração Própria:</span>
                <span class="dots"></span>
                <span class="value">{{ notaFiscal.valorPis | currency }}</span>
              </div>
              <div class="linha-pontilhada linha-zebra">
                <span class="label">COFINS - Débito Apuração Própria:</span>
                <span class="dots"></span>
                <span class="value">{{ notaFiscal.valorCofins | currency }}</span>
              </div>
              <div class="linha-pontilhada linha-zebra">
                <span class="label">Imposto de Renda Retido na Fonte (IRRF):</span>
                <span class="dots"></span>
                <span class="value">{{ (notaFiscal.valorIr || notaFiscal.valorIrrf || 0) | currency }}</span>
              </div>
              <div class="linha-pontilhada linha-zebra">
                <span class="label">Contribuições Sociais - Retidas:</span>
                <span class="dots"></span>
                <span class="value">{{ notaFiscal.valorCsll | currency }}</span>
              </div>
              <div class="linha-pontilhada linha-zebra">
                <span class="label">Contribuição Previdenciária - Retida:</span>
                <span class="dots"></span>
                <span class="value">{{ notaFiscal.valorInss | currency }}</span>
              </div>
            </div>
          </div>

          <!-- Valor líquido da NFS-e -->
          <div class="previa-section mb-4">
            <h4 class="section-title">Valor líquido da NFS-e</h4>
            <div class="previa-body">
              <div class="linha-pontilhada linha-zebra">
                <span class="label">Serviço prestado:</span>
                <span class="dots"></span>
                <span class="value">{{ valorTotalServico | currency }}</span>
              </div>
              <div class="linha-pontilhada linha-zebra">
                <span class="label">Valor total de tributos retidos:</span>
                <span class="dots"></span>
                <span class="value">{{ totalTributosRetidos | currency }}</span>
              </div>
              <div class="linha-pontilhada linha-zebra">
                <span class="label">Valor líquido da NFS-e:</span>
                <span class="dots"></span>
                <span class="value">{{ valorLiquido | currency }}</span>
              </div>
            </div>
          </div>

          <!-- IBS/CBS -->
          <div class="previa-section mb-4">
            <h4 class="section-title">IBS/CBS</h4>
            <div class="previa-body" v-if="totaisIbsCbs && !loadingCalculo">
              <div class="linha-pontilhada linha-zebra">
                <span class="label">Base de Cálculo IBS/CBS:</span>
                <span class="dots"></span>
                <span class="value">{{ ibsCbsBaseCalculo | currency }}</span>
              </div>
              <div class="linha-pontilhada linha-zebra">
                <span class="label">Valor IBS Total:</span>
                <span class="dots"></span>
                <span class="value">{{ ibsTotal | currency }}</span>
              </div>
              <div class="linha-pontilhada linha-zebra">
                <span class="label">Valor CBS Total:</span>
                <span class="dots"></span>
                <span class="value">{{ cbsTotal | currency }}</span>
              </div>
              <div class="linha-pontilhada linha-zebra">
                <span class="label">Alíquota Efetiva CBS:</span>
                <span class="dots"></span>
                <span class="value">{{ cbsAliqEfetiva | percent }}</span>
              </div>
              <div class="linha-pontilhada linha-zebra">
                <span class="label">Valor IBS Estadual:</span>
                <span class="dots"></span>
                <span class="value">{{ ibsEstadualTotal | currency }}</span>
              </div>
              <div class="linha-pontilhada linha-zebra">
                <span class="label">Alíquota Efetiva IBS Estadual:</span>
                <span class="dots"></span>
                <span class="value">{{ ibsEstadualAliqEfetiva | percent }}</span>
              </div>
              <div class="linha-pontilhada linha-zebra">
                <span class="label">Valor IBS Municipal:</span>
                <span class="dots"></span>
                <span class="value">{{ ibsMunicipalTotal | currency }}</span>
              </div>
              <div class="linha-pontilhada linha-zebra">
                <span class="label">Alíquota Efetiva IBS Municipal:</span>
                <span class="dots"></span>
                <span class="value">{{ ibsMunicipalAliqEfetiva | percent }}</span>
              </div>
              
              <div class="memoria-calculo p-2 mt-2 ml-1" v-if="cbsMemoriaCalculo">
                <small class="text-muted">{{ cbsMemoriaCalculo }}</small>
              </div>
            </div>
            <div class="previa-body p-3 text-danger text-center" v-else-if="!loadingCalculo">
              Não foi possível simular os valores de IBS/CBS no momento.
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <Button
        label="Voltar"
        icon="pi pi-angle-left"
        class="p-button-primary mr-2"
        @click="fechar"
      />
      <Button
        label="Imprimir Rascunho"
        icon="pi pi-print"
        class="p-button-success"
        @click="imprimir"
      />
    </template>
  </Dialog>
</template>

<script>
import moment from "moment";
import NotaFiscalNacionalService from "../../services/nfse/notafiscalnacional.service";

export default {
  name: "VisualizacaoDpsIbsCbs",
  props: {
    visivel: {
      type: Boolean,
      default: false,
    },
    simulacaoRequest: {
      type: Object,
      default: null,
    },
    notaFiscal: {
      type: Object,
      required: true,
    },
    prestador: {
      type: Object,
      required: true,
    },
    tomador: {
      type: Object,
      default: null,
    },
    servicoNacional: {
      type: Object,
      default: null,
    },
    informacoesExtras: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      loadingCalculo: false,
      totaisIbsCbs: null,
    };
  },
  watch: {
    visivel(newVal) {
      if (newVal) {
        this.simularCalculo();
      } else {
        this.totaisIbsCbs = null;
      }
    }
  },
  filters: {
    formatDate(value) {
      if (!value) return "";
      return moment(String(value)).format("DD/MM/YYYY");
    },
    formatDocument(value) {
      if (!value) return "";
      let doc = value.replace(/\D/g, "");
      if (doc.length === 11) {
        return doc.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      } else if (doc.length === 14) {
        return doc.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
      }
      return value;
    },
    currency(value) {
      if (!value && value !== 0) return "0,00";
      return parseFloat(value).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    percent(value) {
      if (!value && value !== 0) return "0,00%";
      return parseFloat(value).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) + "%";
    },
  },
  computed: {
    valorTotalServico() {
      return this.notaFiscal.valorServico || 0;
    },
    baseCalculoIssqn() {
      return this.valorTotalServico - (this.notaFiscal.valorDesconto || 0) - (this.notaFiscal.valorDescontoIncond || 0);
    },
    valorLiquido() {
      return this.notaFiscal.valorLiquido || 0;
    },
    totalTributosRetidos() {
      // Valor retido é a diferença entre o serviço e o líquido, desconsiderando as deduções e descontos já abatidos
      let total = this.valorTotalServico - this.valorLiquido - (this.notaFiscal.valorDescontoIncond || 0) - (this.notaFiscal.valorDesconto || 0) - (this.notaFiscal.valorDescontosDiversos || 0);
      return total > 0 ? total : 0;
    },
    ibsCbsBaseCalculo() {
      if(this.totaisIbsCbs && this.totaisIbsCbs.total && this.totaisIbsCbs.total.tribCalc && this.totaisIbsCbs.total.tribCalc.IBSCBSTot) {
         return this.totaisIbsCbs.total.tribCalc.IBSCBSTot.vBCIBSCBS || 0;
      }
      return 0;
    },
    ibsTotal() {
      if(this.totaisIbsCbs && this.totaisIbsCbs.total && this.totaisIbsCbs.total.tribCalc && this.totaisIbsCbs.total.tribCalc.IBSCBSTot && this.totaisIbsCbs.total.tribCalc.IBSCBSTot.gIBS) {
         return this.totaisIbsCbs.total.tribCalc.IBSCBSTot.gIBS.vIBS || 0;
      }
      return 0;
    },
    cbsTotal() {
      if(this.totaisIbsCbs && this.totaisIbsCbs.total && this.totaisIbsCbs.total.tribCalc && this.totaisIbsCbs.total.tribCalc.IBSCBSTot && this.totaisIbsCbs.total.tribCalc.IBSCBSTot.gCBS) {
         return this.totaisIbsCbs.total.tribCalc.IBSCBSTot.gCBS.vCBS || 0;
      }
      return 0;
    },
    cbsAliqEfetiva() {
      if(this.totaisIbsCbs && this.totaisIbsCbs.objetos && this.totaisIbsCbs.objetos.length > 0 && this.totaisIbsCbs.objetos[0].tribCalc && this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS && this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS.gIBSCBS && this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS.gIBSCBS.gCBS) {
         return this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS.gIBSCBS.gCBS.pCBS || 0;
      }
      return 0;
    },
    ibsEstadualTotal() {
      if(this.totaisIbsCbs && this.totaisIbsCbs.objetos && this.totaisIbsCbs.objetos.length > 0 && this.totaisIbsCbs.objetos[0].tribCalc && this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS && this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS.gIBSCBS && this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS.gIBSCBS.gIBSUF) {
         return this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS.gIBSCBS.gIBSUF.vIBSUF || 0;
      }
      return 0;
    },
    ibsEstadualAliqEfetiva() {
      if(this.totaisIbsCbs && this.totaisIbsCbs.objetos && this.totaisIbsCbs.objetos.length > 0 && this.totaisIbsCbs.objetos[0].tribCalc && this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS && this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS.gIBSCBS && this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS.gIBSCBS.gIBSUF) {
         return this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS.gIBSCBS.gIBSUF.pIBSUF || 0;
      }
      return 0;
    },
    ibsMunicipalTotal() {
      if(this.totaisIbsCbs && this.totaisIbsCbs.objetos && this.totaisIbsCbs.objetos.length > 0 && this.totaisIbsCbs.objetos[0].tribCalc && this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS && this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS.gIBSCBS && this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS.gIBSCBS.gIBSMun) {
         return this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS.gIBSCBS.gIBSUF.vIBSMun || 0;
      }
      return 0;
    },
    ibsMunicipalAliqEfetiva() {
      if(this.totaisIbsCbs && this.totaisIbsCbs.objetos && this.totaisIbsCbs.objetos.length > 0 && this.totaisIbsCbs.objetos[0].tribCalc && this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS && this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS.gIBSCBS && this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS.gIBSCBS.gIBSMun) {
         return this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS.gIBSCBS.gIBSUF.pIBSMun || 0;
      }
      return 0;
    },
    cbsMemoriaCalculo() {
      if(this.totaisIbsCbs && this.totaisIbsCbs.objetos && this.totaisIbsCbs.objetos.length > 0 && this.totaisIbsCbs.objetos[0].tribCalc && this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS && this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS.gIBSCBS && this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS.gIBSCBS.gCBS) {
         return this.totaisIbsCbs.objetos[0].tribCalc.IBSCBS.gIBSCBS.gCBS.memoriaCalculo || "";
      }
      return "";
    }
  },
  methods: {
    simularCalculo() {
      if (!this.simulacaoRequest) return;
      
      this.loadingCalculo = true;
      this.totaisIbsCbs = null;
      
      NotaFiscalNacionalService.simularCalculoIbsCbs(this.simulacaoRequest)
        .then((response) => {
          this.totaisIbsCbs = response;
        })
        .catch((error) => {
          console.error("Erro ao simular IBS/CBS", error);
          let msg = "Não foi possível simular os valores de IBS/CBS.";
          if (error.response && error.response.data) {
            msg = error.response.data.message || error.response.data || msg;
          } else if (error.message) {
            msg = error.message;
          }
          this.$toast.add({ severity: 'error', summary: 'Erro', detail: msg, life: 5000 });
          this.fechar();
        })
        .finally(() => {
          this.loadingCalculo = false;
        });
    },
    fechar() {
      this.$emit("update:visivel", false);
    },
    imprimir() {
      setTimeout(() => {
        window.print();
      }, 300);
    },
  },
};
</script>

<style scoped>
::v-deep .p-dialog-content {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #333;
}
.font-weight-bold {
  font-weight: bold;
}

/* Estilos para a Prévia de Valores (Modelo Nacional) */
.previa-titulo {
  color: #666;
  font-size: 1.05rem;
  font-weight: 600;
}
.previa-section {
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 20px;
}
.previa-section .section-title {
  background-color: #e3f2fd;
  color: #1565c0;
  padding: 8px 12px;
  font-size: 0.95rem;
  font-weight: bold;
  margin: 0;
  border-bottom: 1px solid #bbdefb;
}
.previa-body {
  background-color: #f5f9ff;
  padding: 8px 0;
  border: 1px solid #bbdefb;
  border-top: none;
  border-radius: 0 0 4px 4px;
}
.linha-pontilhada {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 4px 16px;
}
.linha-zebra:nth-child(even) {
  background-color: rgba(255, 255, 255, 0.4);
}
.linha-pontilhada > .label {
  color: #444;
  font-size: 0.85rem;
  white-space: nowrap;
}
.linha-pontilhada > .dots {
  flex-grow: 1;
  border-bottom: 1px dotted #999;
  margin: 0 10px;
  position: relative;
  top: -4px;
}
.linha-pontilhada > .value {
  font-weight: 600;
  color: #333;
  font-size: 0.85rem;
  white-space: nowrap;
}
.memoria-calculo small {
  font-size: 0.75rem;
  color: #555 !important;
}

/* Estilos das novas seções superiores (PESSOAS, SERVIÇOS, VALORES) */
.nacional-section-main-title {
  font-size: 1.1rem;
  font-weight: 500;
  text-transform: uppercase;
  margin-top: 15px;
  margin-bottom: 20px;
  color: #333;
}
.nacional-section-title {
  font-size: 1.0rem;
  font-weight: 600;
  color: #555;
  padding: 5px 0;
  margin-top: 10px;
  margin-bottom: 10px;
}
.nacional-block {
  background-color: #f7f7f7;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  padding: 15px 0;
}
.nacional-row {
  display: flex;
  align-items: baseline;
  justify-content: center;
  margin-bottom: 8px;
}
.nacional-row:last-child {
  margin-bottom: 0;
}
.nacional-label {
  flex: 1;
  text-align: right;
  color: #777;
  font-size: 0.9rem;
  padding-right: 15px;
}
.nacional-value {
  flex: 1;
  text-align: left;
  font-style: italic;
  font-size: 0.9rem;
  color: #222;
  padding-left: 15px;
}
</style>

<style>
@media print {
  body * {
    visibility: hidden;
  }
  .dialog-visualizacao-dps, .dialog-visualizacao-dps * {
    visibility: visible;
  }
  .dialog-visualizacao-dps {
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    height: auto !important;
    box-shadow: none !important;
    background: white !important;
    border: none !important;
  }
  .p-dialog-mask {
    position: absolute !important;
    background: transparent !important;
    visibility: visible !important;
    align-items: flex-start !important;
  }
  .p-dialog-header-icons,
  .p-dialog-footer {
    display: none !important;
  }
  .p-dialog-content {
    overflow: visible !important;
    max-height: none !important;
    border: none !important;
  }
}
</style>
